  import { Icon } from "@iconify/react";
  import React, { useState, useRef, useEffect } from "react";
  import { notificationService } from "../../services/notificationService";
  import { Toast } from "primereact/toast";
  import { Notifications } from "../../models/Transaction";
  import { formatDate } from "../../utils/functions";
  import { useSelector } from "react-redux";
  import { RootState } from "../../redux/store";
  import { Button } from "primereact/button";
  import { SOCKET_EVENTS } from "../../utils/socketEvents";
  import { socket } from "../../utils/socket";



  export const NotificationButton = () => {
    const toastRef = useRef<Toast>(null);
    const [isOpen, setIsOpen] = useState(false);
    const [showAll, setShowAll] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const [notification, setNotification] = useState<Notifications[]>([]);
    const { currentUser, loading } = useSelector(
      (state: RootState) => state.auth
    );
  
    const [selectedNotification, setSelectedNotification] = useState<Notifications | null>(null);
    const [showModal, setShowModal] = useState(false);


    
    const handleNotificationClick = async (notif: Notifications) => {
      try {
        await notificationService.readNotification(notif.id!);
    
          setNotification((prev) =>
          prev.map((n) =>
            n.id === notif.id ? { ...n, isRead: true } : n
          )
        );
    
        setSelectedNotification(notif);
        setShowModal(true);
      } catch (error) {
        toastRef.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: "Impossible to show notification as read.",
        });
      }
    };
    
      const fetchNotifications = async () => {
        try {
          if (!currentUser || !currentUser.role?.role_code) return;

          const roleCode = currentUser.role.role_code;

          if (roleCode === "CUSTOMER" || roleCode === "ENTERPRISE") {
            const res = await notificationService.getUserNotification();
            setNotification(res.data);
          } else if (roleCode === "ADMIN" || "SUPERADMIN") {
            const adminRes = await notificationService.getAdminNotification();
            setNotification(adminRes.data);
          } else {
            toastRef.current?.show({
            severity: "error",
            summary: "Error",
            detail: "Failed to fetch notifications",
          });
          }
        } catch (error) {
          toastRef.current?.show({
            severity: "error",
            summary: "Error",
            detail: "Failed to fetch notifications",
          });
        }
      };

      
      const handleDeleteNotification = async (e: React.MouseEvent, id: string) => {
        e.stopPropagation(); 
        e.preventDefault();
        try {
          await notificationService.deleteNotification(id);
          setNotification((prev) => prev.filter((notif) => notif.id !== id));
        } catch (error) {
          toastRef.current?.show({
            severity: "error",
            summary: "Error",
            detail: "Error while deleting notification",
          });
        }
      };
      
    const handleToggle = () => {
      setIsOpen((prev) => !prev);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
          setIsOpen(false);
          setShowAll(false); 
        }
    };

    useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);
  
    useEffect(() => {
    const refreshNotificationsOnEvent = () => {
      fetchNotifications();
    };

    const events = Object.values(SOCKET_EVENTS);

    events.forEach((event) => {
      socket.on(event, refreshNotificationsOnEvent);
    });

    return () => {
      events.forEach((event) => {
        socket.off(event, refreshNotificationsOnEvent);
      });
    };
  }, []);

  const visibleNotifications = showAll ? notification : notification.slice(0, 3);

  return (
      <div className="relative" ref={dropdownRef}>
        <button
          onClick={handleToggle}
          className="has-indicator w-12 h-12 rounded-full flex justify-center items-center"
          type="button"
        >
          <Icon icon="iconoir:bell" className="text-primary-light text-lg translate-x-2/3" />
            {notification?.filter(n => !n.isRead).length > 0 && (
            <span className="absolute top-2 right-0 translate-x-1/2 translate-y-1/3 bg-red-500 text-white text-[8px] font-bold w-3 h-3 flex items-center justify-center rounded-full">
              {/* {notification.length} */}
              {notification.filter(n => !n.isRead).length}
            </span>
          )}
        </button>
        {isOpen && (
          <div className="absolute right-0 mt-2 w-96 bg-white border rounded-lg shadow-lg z-50 overflow-hidden">
            <div className="p-1 flex justify-between items-center bg-primary-50">
              <p className="text-xs text-primary-light font-semibold pl-2 mb-0">Notifications</p>
              <span className="text-primary-600 font-semibold text-xs w-8 h-8 rounded-full bg-base flex justify-center items-center">
              {notification.length}
              </span>
            </div>

            <div className="max-h-72 overflow-y-auto p-4 space-y-2">
              {visibleNotifications.map((notif) => (
                <a key={notif.id} href="#" 
                onClick={(e) => {
                  e.preventDefault();
                  handleNotificationClick(notif);
                }}
                className={`flex items-center gap-3 p-3 hover:bg-gray-100 rounded-lg ${
                  notif.isRead === false  ? 'bg-secondary-100' : ''
                }`}
                >
                  <div className="flex-1 overflow-hidden">
                    {/* <h6 className="font-semibold text-xs mb-1">{notif.message}</h6> */}
                    <p className="text-xs text-gray-500"
                      style={{ whiteSpace: 'nowrap', overflow: 'hidden',
                      textOverflow: 'ellipsis', maxWidth: '100px' }} >
                      {notif.message}</p>
                    
                  </div>
                  <span className="text-xs text-gray-400 flex-shrink-0">{formatDate(notif.createdAt)}</span>
                    <Button
                        className="text-red-500 hover:text-red-700 text-sm"
                        icon="pi pi-trash"
                        onClick={(e) => handleDeleteNotification(e, notif.id!)}
                        title="Delete"
                      />
                </a>
              ))}
            </div>

            <div className="text-center py-4 border-t">
              {!showAll ? (
                <button
                  className="text-primary-600 font-semibold text-xs hover:text-primary-500"
                  onClick={() => setShowAll(true)}
                >
                  See All Notifications
                </button>
              ) : (
                <button
                  className="text-primary-600 font-semibold text-xs hover:text-primary-500"
                  onClick={() => setShowAll(false)}
                >
                  Show Less
                </button>
              )}
            </div>
          </div>
        )}
        {showModal && selectedNotification && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-30 flex items-center justify-center">
            <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6 relative">
              <button
                onClick={() => setShowModal(false)}
                className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
              >
                &times;
              </button>
              <h2 className="text-lg font-semibold">Notification</h2>
              <p className="text-sm text-gray-700 mb-4">{selectedNotification.message}</p>
              <p className="text-xs text-gray-400">Issued Date {formatDate(selectedNotification.createdAt)}</p>
            </div>
          </div>
        )}

      </div>
    );
  };


